export default {

    error (commit, error) {
        return commit('toast/ADD_TOAST', { type: "error", message: error.body.message }, { root: true })
    },

    success (commit, message) {
        return commit('toast/ADD_TOAST', { type: "success", message: message }, { root: true })
    }

}


// WEBPACK FOOTER //
// ./src/plugins/api.js